import type { DeliveryCard } from "@/components/landing/Delivery/types";
import { Glyph, ParcelLogo } from "@/components/landing/shared";

interface DeliveryCardHeaderProps {
	card: DeliveryCard;
}

function DeliveryCardHeader(prop: DeliveryCardHeaderProps) {
	const { card } = prop;
	return (
		<div className="flex flex-wrap items-start justify-between gap-6">
			<div className="flex gap-4">
				<span
					className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl"
					style={{ background: "linear-gradient(135deg, #fbbf24, #f59e0b)" }}
				>
					<Glyph name="parcel" className="h-6 w-6 text-white" />
				</span>
				<div className="">
					<h3 className="flex flex-wrap items-baseline font-semibold space-x-1">
						<span>{card.title}</span>
						<a
							href="https://tryparcel.com/"
							target="_blank"
							rel="noopener noreferrer"
							aria-label="Parcel"
						>
							<ParcelLogo
								className="relative top-px ml-1.5 h-4.25 w-auto shrink-0"
								aria-label="Parcel"
							/>
						</a>
					</h3>
					<p className="mt-1 max-w-md text-sm leading-relaxed text-muted-foreground">{card.desc}</p>
				</div>
			</div>
			<div className="flex shrink-0 flex-col items-end gap-2">
				<span
					className="badge gap-1"
					style={{
						background: "color-mix(in srgb, var(--success) 14%, transparent)",
						color: "var(--success)",
					}}
				>
					<Glyph name="check" className="h-3 w-3" />
					{card.connected}
				</span>
				<span className="badge gap-1.5 bg-surface-2 text-muted-foreground">
					<span className="relative grid h-1.5 w-1.5 place-items-center">
						<span
							className="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
							style={{ background: "var(--brand-2)" }}
						/>
						<span
							className="relative h-1.5 w-1.5 rounded-full"
							style={{ background: "var(--brand-2)" }}
						/>
					</span>
					{card.liveTracking}
				</span>
			</div>
		</div>
	);
}

export default DeliveryCardHeader;
